import { Global } from '@emotion/react';
import { tokensAsCssCustomProperties } from '@workiva/unify-tokens-raw';
import * as React from 'react';
import {
  defaultUnifyStyleContextValue,
  useUnifyStyleContext,
} from 'src/styles/context/unifyStyleContext';

/**
 * A custom component to place within UnifyThemeProvider that will
 * make the tokens from `unify-tokens` available as
 * CSS custom properties via the `theme.getCssVar` function and/or
 * the `getToken` function from the `unify-tokens` package.
 *
 * @access package
 */
export const GlobalUnifyTokensStyles: React.FC =
  function GlobalUnifyTokensStyles() {
    const { colorSchemeAttribute } =
      useUnifyStyleContext() ?? defaultUnifyStyleContextValue;

    //language=CSS
    const styles = `:root, [${colorSchemeAttribute}="light"] {
  ${tokensAsCssCustomProperties['light']}
}

[${colorSchemeAttribute}="dark"] {
  ${tokensAsCssCustomProperties['dark']}
}`;

    return <Global styles={styles} />;
  };

export default GlobalUnifyTokensStyles;
